export default "__VITE_ASSET__81f0e38a__"